import { render } from "./Slogan1.vue.vue?vue&type=template&id=f4b04f88&scoped=true&lang=true"
import script from "./Slogan1.vue.vue?vue&type=script&lang=js"
export * from "./Slogan1.vue.vue?vue&type=script&lang=js"

import "./Slogan1.vue.vue?vue&type=style&index=0&id=f4b04f88&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4b04f88"]])

export default __exports__